import { FC } from 'react'
import * as styles from 'components/features/pfm/DesktopInternalStickyHeader/DesktopInternalStickyHeader.styl'
import StickyHeader from 'components/unorganized/StickyHeader'

export type DesktopInternalStickyHeaderProps = {
  isShown: () => boolean
  noAnimation?: boolean
}
export const DesktopInternalStickyHeader: FC<DesktopInternalStickyHeaderProps> = (props) => {
  const { isShown, children, noAnimation } = props

  return (
    <StickyHeader isScrolled={ isShown } className={ styles.header } noAnimation={ noAnimation }>
      { children }
    </StickyHeader>
  )
}
